// Knowledge base items + import jobs.
import { apiClient } from "../apiClient";

const send = (url, method, body) => apiClient(url, { method, body: body === undefined ? undefined : JSON.stringify(body) }).then((res) => res.data);

export const listKnowledge = () => apiClient("/api/knowledge").then((res) => res.data);
export const createKnowledge = (payload) => send("/api/knowledge", "POST", payload);
export const updateKnowledge = (id, patch) => send(`/api/knowledge/${id}`, "PATCH", patch);
export const setKnowledgeStatus = (id, status) => updateKnowledge(id, { status });
export const deleteKnowledge = (id) => send(`/api/knowledge/${id}`, "DELETE");
/** payload: { kind: "document" | "url", fileName? , url?, title?, category? } */
export const startImport = (payload) => send("/api/knowledge/import", "POST", payload);
export const listImports = () => apiClient("/api/knowledge/import").then((res) => res.data);
export const getImport = (id) => apiClient(`/api/knowledge/import/${id}`).then((res) => res.data);
